import { render, staticRenderFns } from "./SvehiclesalesreceiptUpdate.vue?vue&type=template&id=4ffd0ee2&scoped=true"
import script from "./SvehiclesalesreceiptUpdate.vue?vue&type=script&lang=js"
export * from "./SvehiclesalesreceiptUpdate.vue?vue&type=script&lang=js"
import style0 from "./SvehiclesalesreceiptUpdate.vue?vue&type=style&index=0&id=4ffd0ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd0ee2",
  null
  
)

export default component.exports